
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wifi-networks",
      function () {
        return require("private-next-pages/wifi-networks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wifi-networks"])
      });
    }
  